import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;

  & > span {
    display: flex;
    align-items: flex-end;
    font-size: 1.2rem;
    color: #738a94;
    margin: 0.5rem 0;

    &:before {
      content: "barbarbar";
      font-size: 0.6rem;
      border-top: 3px solid #09100F;
      margin-right: 1rem;
      color: #ffffff;
      background: #ffffff;
    }
  }

  // display: inline-block;
  // position: relative;
  // z-index: 1;
  // border-radius: 100px;
  // font-size: 14px;
  // font-style: normal;
  // font-weight: 400;
  // line-height: 17px;
  // padding: 8px 12px;
  // cursor: pointer;

  ${(props) => props.thisStyles};
`;
